import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMagicBook: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="magic-book, magician, sparkles"><path fillRule="evenodd" clipRule="evenodd" d="M4 2H20V22H4V2ZM5.5 18V20.5H18.5V18H5.5ZM18.5 16.5H5.5V3.5H18.5V16.5Z" fill="currentColor"/><path d="M12.3333 7.33333L13.5 5L14.6667 7.33333L17 8.5L14.6667 9.66667L13.5 12L12.3333 9.66667L10 8.5L12.3333 7.33333Z" fill="currentColor"/><path d="M8.66667 11.6667L9.5 10L10.3333 11.6667L12 12.5L10.3333 13.3333L9.5 15L8.66667 13.3333L7 12.5L8.66667 11.6667Z" fill="currentColor"/></CentralIconBase>;
};

export default IconMagicBook;
